import TalkOnAgile from './TalkOnAgile';

export default TalkOnAgile;